import type { OutcomeParameterName, OutcomeParameterValue } from '../../../types';

/**
 * Строит ключ из пар (name, value)
 *
 * Сортировка по имени включается только при наличии более одного элемента,
 * это убирает накладные расходы на копирование массива и сортировку
 */
export function buildGroupKey(
    pairs: ReadonlyArray<readonly [OutcomeParameterName, OutcomeParameterValue]>,
): string {
    if (pairs.length === 0) {
        return '';
    }
    if (pairs.length === 1) {
        return `${pairs[0][0]}=${pairs[0][1]}`;
    }
    return [...pairs]
        .sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0))
        .map(([n, v]) => `${n}=${v}`)
        .join('|');
}
